<template>
<div class="modal micromodal-slide change_data" v-bind:class="{ 'is-open': this.open }">
  <div class="modal__overlay" v-on:click="close()"></div>
  <div class="modal_item">
    <div class="detail_wrap">
      <button v-on:click="close()" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
      <h2 class="content_title">登録住所</h2>
      <div class="scroll mt24" ref="modal__content">


        <div v-for="(index, n) in deliveryAddressList" :key="n" class="payment_item right_arrow bdb pl16 pr20 pb10" v-bind:class="{ 'pt11': n != 0 }">
          <input v-bind:checked="checkedItem == index.deliveryAddressId" v-bind:id="'address' + n" class="payment_radio" type="radio" name="address">
          <label v-bind:for="'address' + n" class="payment_contents rb" v-on:click="changeAddress(index.deliveryAddressId)">
            {{ index.recipientName }}
            <span class="zip rs">〒{{ index.address.zipCode }}</span>
            <span class="address rs">{{ index.address.prefecture.prefectureName }} {{ index.address.address }}</span>
          </label>
        </div>
        <div v-if="subscriptionNowBC != '001'" class="payment_item right_arrow bdb pl16 pr20 pb10 pt11">
          <input v-bind:checked="checkedItem == 0" id="sameWithBc" class="payment_radio" type="radio" name="address">
          <label for="sameWithBc" class="payment_contents rb" v-on:click="changeAddress(0)">
            BC001と同じ配送先に設定する
            <span class="zip rs"></span>
            <span class="address rs"></span>
          </label>
        </div>

      </div>
    </div>
    <div class="btn_wrap">
      <button v-on:click="send()" class="btn_yellow">この住所に届ける</button>
      <a href="#" class="btn_blue" @click.stop.prevent="addAddress()">住所を追加する</a>
      <!-- <router-link :to="{ name: 'addAddress', query: {redirect_url: 'repeatSelectPaymentAndShipping'} }" class="btn_blue mt12">住所を追加する</router-link> -->
    </div>
  </div>
</div>

</template>

<script>
import DeliveryAddress from '@/components/api/deliveryAddress'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      open: false,
      deliveryAddressId: null,
      deliveryAddressList: [],
      sameWithBc: false,
      checkedItem: null,
    }
  },
  methods: {
    addAddress() {
      // userDetailの情報をここで一度保存する（SubDetailInformationのnextBtn）
      localStorage.setItem('userDetail', JSON.stringify(this.userDetail));
      this.close();
      this.$router.push({ name: 'addAddress', query: {redirect_url: 'repeatSelectPaymentAndShipping'} });
    },
    isShow() {
      this.open = true;
    },
    changeAddress(deliveryId) {
      this.checkedItem = deliveryId;
      this.deliveryAddressId = deliveryId;
      if(deliveryId == 0) {
        this.sameWithBc = true;
      } else {
        this.sameWithBc = false;
      }
    },
    close() {
      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      this.open = false;
    },
    send() {
      this.$store.commit('setSubscriptionDeliveryAddressViewSameWithBc001', this.sameWithBc);

      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      this.apiUpdateDeliveryAddress();
      let findItem = this.deliveryAddressList.findIndex((value) => value.deliveryAddressId == this.deliveryAddressId);
      // console.log(this.deliveryAddressList[findItem]);
      if(this.sameWithBc) {
        findItem = this.deliveryAddressList.findIndex((value) => value.sameWithBc001 == true);
        // this.deliveryAddressList[findItem].message = '※BC001の配送住所情報を使用します。';
      }
      // console.log(findItem);
      if(findItem == -1) {
        // this.defaultDeliveryData(this.deliveryAddressList);
        let data = {
          recipientName: '',
          deliveryAddressId: 0,
          address: {
            zipCode: '',
            prefecture: {
              prefectureName: '',
            },
            address: '',
          },
          selected: true,
          sameWithBc001: true,
        }

        // store用
        // let storeData = {
        //   recipientName: this.subscriptionDeliveryAddressSameWithBc001RecipientName,
        //   deliveryAddressId: this.subscriptionDeliveryAddressSameWithBc001DeliveryAddressId,
        //   address: {
        //     zipCode: this.subscriptionDeliveryAddressSameWithBc001ZipCode,
        //     prefecture: {
        //       prefectureName: this.subscriptionDeliveryAddressSameWithBc001PrefectureName,
        //     },
        //     address: this.subscriptionDeliveryAddressSameWithBc001Address,
        //   },
        //   selected: this.subscriptionDeliveryAddressSameWithBc001Seleced,
        //   sameWithBc001: this.subscriptionDeliveryAddressSameWithBc001,
        // }

        this.storeActionsDeliveryAddressData(data);

        this.$emit('deliveryAddressData', data);

        this.deliveryAddressList[findItem]
      } else {
        this.$emit('deliveryAddressData', this.deliveryAddressList[findItem]);

        // this.$store.dispatch(
        //   'commitUserDetailDeliveryAddressData', {
        //     recipientName: this.deliveryAddressList[findItem].recipientName,
        //     deliveryAddressId: this.deliveryAddressList[findItem].deliveryAddressId,
        //     zipCode: this.deliveryAddressList[findItem].address.zipCode,
        //     prefectureName: this.deliveryAddressList[findItem].address.prefecture.prefectureName,
        //     address: this.deliveryAddressList[findItem].address.address,
        //     sameWithBc001: this.deliveryAddressList[findItem].sameWithBc001,
        //   });
          this.storeActionsDeliveryAddressData(this.deliveryAddressList[findItem]);
      }

      this.open = false;
    },
    storeActionsDeliveryAddressData(data) {
      this.$store.dispatch(
        'commitUserDetailDeliveryAddressData', {
          recipientName: data.recipientName,
          deliveryAddressId: data.deliveryAddressId,
          zipCode: data.address.zipCode,
          prefectureName: data.address.prefecture.prefectureName,
          address: data.address.address,
          sameWithBc001: data.sameWithBc001,
        });
    },
    defaultDeliveryData(data) {
      for (var i = 0; i < data.length; i++) {
        if(data[i].selected && data[i].sameWithBc001) {
          this.deliveryAddressId = 0;
          this.checkedItem = 0;

          console.log('-----');
          console.log(data[i]);
          console.log('-----');

          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001RecipientName', data[i].recipientName);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001DeliveryAddressId', data[i].deliveryAddressId);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001ZipCode', data[i].address.zipCode);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001PrefectureName', data[i].address.prefecture.prefectureName);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001Address', data[i].address.address);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001', data[i].sameWithBc001);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001Seleced', data[i].selected);

          this.$store.commit('setSubscriptionDeliveryAddressViewSameWithBc001', true);
          // this.$store.dispatch(
          //   'commitUserDetailDeliveryAddressData', {
          //     recipientName: data[i].recipientName,
          //     deliveryAddressId: data[i].deliveryAddressId,
          //     zipCode: data[i].address.zipCode,
          //     prefectureName: data[i].address.prefecture.prefectureName,
          //     address: data[i].address.address,
          //     sameWithBc001: data[i].sameWithBc001,
          //   });

            this.storeActionsDeliveryAddressData(data[i]);

          this.$emit('deliveryAddressData', data[i]);
          return false;
        } else if(data[i].selected) {
          console.log(data[i]);
          this.deliveryAddressId = data[i].deliveryAddressId;
          this.checkedItem = data[i].deliveryAddressId;

          // this.$store.dispatch(
          //   'commitUserDetailDeliveryAddressData', {
          //     recipientName: data[i].recipientName,
          //     deliveryAddressId: data[i].deliveryAddressId,
          //     zipCode: data[i].address.zipCode,
          //     prefectureName: data[i].address.prefecture.prefectureName,
          //     address: data[i].address.address,
          //     sameWithBc001: data[i].sameWithBc001,
          //   });
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001RecipientName', data[i].recipientName);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001DeliveryAddressId', data[i].deliveryAddressId);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001ZipCode', data[i].address.zipCode);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001PrefectureName', data[i].address.prefecture.prefectureName);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001Address', data[i].address.address);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001', data[i].sameWithBc001);
          this.$store.commit('setSubscriptionDeliveryAddressSameWithBc001Seleced', data[i].selected);

          this.$store.commit('setSubscriptionDeliveryAddressViewSameWithBc001', false);
          this.$emit('deliveryAddressData', data[i]);
          this.storeActionsDeliveryAddressData(data[i]);

          return false;
        }
      }
    },
    async apiGetdDeliveryAddress() {
      let bc = localStorage.getItem('subNowBC');
      await DeliveryAddress.getDeliveryAddressList(bc).then((val) => {

        console.log('address');
        console.log(val);
        this.deliveryAddressList.push(...val.deliveryAddressList);
        // apiから返却されたデフォルトの値をセット
        this.defaultDeliveryData(val.deliveryAddressList);
        // let userDetail = JSON.parse(localStorage.getItem('userDetail'));
        // if(userDetail) {
        //   // APIで取得した一覧にストレージのaddressIdの値があるか検索
        //   let findItem = this.deliveryAddressList.findIndex((value) => value.deliveryAddressId == userDetail.deliveryAddressData.deliveryAddressId);
        //   if(findItem != -1) {
        //     // 一覧に一致するIDがあった場合
        //     this.deliveryAddressId = userDetail.deliveryAddressData.deliveryAddressId;
        //     this.checkedItem = userDetail.deliveryAddressData.deliveryAddressId;
        //     this.$emit('deliveryAddressData', this.deliveryAddressList[findItem]);
        //   } else {
        //     // 一覧に一致するIDがなかった場合
        //     this.defaultDeliveryData(val.deliveryAddressList);
        //   }
        // } else {
        //   // ストレージにデータがなかった場合
        //   this.defaultDeliveryData(val.deliveryAddressList);
        // }
      });
    },
    async apiUpdateDeliveryAddress() {
      // let deliveryAddressId = ;
      let bc = localStorage.getItem('subNowBC');
      DeliveryAddress.updateDeliveryAddress(bc, this.deliveryAddressId, this.sameWithBc).then((val) => {
        console.log(val);
        // 成功している場合は空('')で返ってくる8/16現在ではselectedが切り替わらない
      });
    },
  },
  computed: mapGetters([
    'subscriptionNowBC',
    'subscriptionDeliveryAddressSameWithBc001RecipientName',
    'subscriptionDeliveryAddressSameWithBc001DeliveryAddressId',
    'subscriptionDeliveryAddressSameWithBc001ZipCode',
    'subscriptionDeliveryAddressSameWithBc001PrefectureName',
    'subscriptionDeliveryAddressSameWithBc001Address',
    'subscriptionDeliveryAddressSameWithBc001',
    'subscriptionDeliveryAddressSameWithBc001Seleced',
    'subscriptionDeliveryAddressViewSameWithBc001',
    'userDetail',
  ]),
  created() {
    if(this.$route.query.status == 'addDeliveryAddress') {
      this.open = true;
    }
    this.apiGetdDeliveryAddress();
  }
}
</script>

<style lang="css" scoped>
.content_title {
  letter-spacing: 3px;
  width: 103px;
}

.zip, .address {
  display: block;
  font-size: 14px;
}

.btn_yellow {
  margin-top: 8px;
}

/* 消したいけど消すとチェックされた時に青丸が出てこない */
.payment_contents {
  color: #c9c9c9;
  cursor: pointer;
  display: block;
  padding-left: 28px;
  position: relative;
  width: 100%;
}

.payment_contents::before,
.payment_contents::after {
  bottom: 0;
  border-radius: 100px;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
}
.payment_contents::before {
  background: #F5F5F5;
  border: 1px solid #AAAAAA;
  height: 20px;
  left: 0;
  width: 20px;
}

.payment_radio:checked + .payment_contents {
  color: #5a5a5a;
}

.payment_radio:checked + .payment_contents::after {
  background: #00C2FF;
  height: 12px;
  left: 5px;
  width: 12px;
}

.payment_radio {
  display: none;
}

.modal_item {
  /* overflow: scroll; */
  padding-bottom: 100px;
}

.modal_item .scroll {
  max-height: 200px;
  padding-bottom: 40px;
}

.btn_blue {
  margin: 15px auto 0;
}
.btn_wrap {
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/subscription/SelectAddress.vue